import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c35e8c96&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c35e8c96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e8c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35e8c96')) {
      api.createRecord('c35e8c96', component.options)
    } else {
      api.reload('c35e8c96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c35e8c96&scoped=true", function () {
      api.rerender('c35e8c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/salesKPIManagement/index.vue"
export default component.exports